import * as React from 'react';
import { Panel } from '@ixicare/ui';
import siteWrapper, { SiteWrapperProps } from '../utils/siteWrapper';
import { DrawTool } from '~modules/draw-tool';

interface SiteFloorUpdateProps extends SiteWrapperProps {
  planeId: number;
}

const SiteFloorUpdatePage: React.FC<SiteFloorUpdateProps> = ({ site, planeId }) => {
  return (
    <Panel>
      <DrawTool site={site} planeId={planeId} />
    </Panel>
  );
};

export default siteWrapper(SiteFloorUpdatePage, ({ query }) => {
  const { planeId } = query;
  return {
    planeId: parseInt(planeId, 10),
  };
});
